import FaceCardFormatterDeck from "../FaceCardFormatterDeck";
import { BasicsDeckFace } from "../BasicWords/BasicWordsOv";

//images
import kgDeckIMG from "../../assets/DeckCards/Phonetics/kgDeckIMG.png";
import chtDeckIMG from "../../assets/DeckCards/Phonetics/chtDeckIMG.png";
import dtDeckIMG from "../../assets/DeckCards/Phonetics/dtDeckIMG.png";
import hDeckIMG from "../../assets/DeckCards/Phonetics/hDeckIMG.png";
import chjDeckIMG from "../../assets/DeckCards/Phonetics/chjDeckIMG.png";
import jjDeckIMG from "../../assets/DeckCards/Phonetics/jjDeckIMG.png";
import kDeckIMG from "../../assets/DeckCards/Phonetics/kDeckIMG.png";
import kkDeckIMG from "../../assets/DeckCards/Phonetics/kkDeckIMG.png";
import mDeckIMG from "../../assets/DeckCards/Phonetics/mDeckIMG.png";
import nDeckIMG from "../../assets/DeckCards/Phonetics/nDeckIMG.png";
import pbDeckIMG from "../../assets/DeckCards/Phonetics/pbDeckIMG.png";
import pDeckIMG from "../../assets/DeckCards/Phonetics/pDeckIMG.png";
import ppDeckIMG from "../../assets/DeckCards/Phonetics/ppDeckIMG.png";
import rlDeckIMG from "../../assets/DeckCards/Phonetics/rlDeckIMG.png";
import silentngDeckIMG from "../../assets/DeckCards/Phonetics/silentngDeckIMG.png";
import ssDeckIMG from "../../assets/DeckCards/Phonetics/ssDeckIMG.png";
import stDeckIMG from "../../assets/DeckCards/Phonetics/stDeckIMG.png";
import ttDeckIMG from "../../assets/DeckCards/Phonetics/ttDeckIMG.png";
import tDeckIMG from "../../assets/DeckCards/Phonetics/tDeckIMG.png";



export const ConsonantVowelDeckFace = [

        {
        id: "cv_k-g",
        Title: "ㄱ (k/g)",
        Description: "Learn how to pronounce the letter ㄱ!",
        Difficulty: "Beginner 1",
        Image: kgDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_K_G_DECK",
        cssId: "cv_k_ID"
    },
    {
        id: "cv_n",
        Title: "ㄴ (n)",
        Description: "Learn how to pronounce the letter ㄴ!",
        Difficulty: "Beginner 1",
        Image: nDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_N_DECK",
        cssId: "cv_n_ID"
    },
    {
        id: "cv_d-t",
        Title: "ㄷ (d/t)",
        Description: "Learn how to pronounce the letter ㄷ!",
        Difficulty: "Beginner 1",
        Image: dtDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_D_T_DECK",
        cssId: "cv_d-t_ID"
    },
    {
        id: "cv_r-l",
        Title: "ㄹ (r/l)",
        Description: "Learn how to pronounce the letter ㄹ!",
        Difficulty: "Beginner 1",
        Image: rlDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_R_L_DECK",
        cssId: "cv_r-l_ID"
    },
    {
        id: "cv_m",
        Title: "ㅁ (m)",
        Description: "Learn how to pronounce the letter ㅁ!",
        Difficulty: "Beginner 1",
        Image: mDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_M_DECK",
        cssId: "cv_m_ID"
    },
    {
        id: "cv_b-p",
        Title: "ㅂ (b/p)",
        Description: "Learn how to pronounce the letter ㅂ!",
        Difficulty: "Beginner 1",
        Image: pbDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_P_B_DECK",
        cssId: "cv_b-p_ID"
    },
    {
        id: "cv_s-t",
        Title: "ㅅ (s/t)",
        Description: "Learn how to pronounce the letter ㅅ!",
        Difficulty: "Beginner 1",
        Image: stDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_S_T_DECK",
        cssId: "cv_s-t_ID"
    },
    {
        id: "cv_silent-ng",
        Title: "ㅇ (silent/ng)",
        Description: "Learn how to pronounce the letter ㅇ!",
        Difficulty: "Beginner 1",
        Image: silentngDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_SILENT_NG_DECK",
        cssId: "cv_silent-ng_ID"
    },
    {
        id: "cv_ch-j",
        Title: "ㅈ (ch/j)",
        Description: "Learn how to pronounce the letter ㅈ!",
        Difficulty: "Beginner 1",
        Image: chjDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_CH_J_DECK",
        cssId: "cv_j-ch_ID"
    },
    {
        id: "cv_ch-t",
        Title: "ㅊ (ch/t)",
        Description: "Learn how to pronounce the letter ㅊ!",
        Difficulty: "Beginner 1",
        Image: chtDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_CH_T_DECK",
        cssId: "cv_ch-t_ID"
    },
    {
        id: "cv_k",
        Title: "ㅋ (k)",
        Description: "Learn how to pronounce the letter ㅋ!",
        Difficulty: "Beginner 1",
        Image: kDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_K_DECK",
        cssId: "cv_k_ID"
    },
    {
        id: "cv_t",
        Title: "ㅌ (t)",
        Description: "Learn how to pronounce the letter ㅌ!",
        Difficulty: "Beginner 1",
        Image: tDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_T_DECK",
        cssId: "cv_t_ID"
    },
    {
        id: "cv_p",
        Title: "ㅍ (p)",
        Description: "Learn how to pronounce the letter ㅍ!",
        Difficulty: "Beginner 1",
        Image: pDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_P_DECK",
        cssId: "cv_p_ID"
    },
    {
        id: "cv_h",
        Title: "ㅎ (h)",
        Description: "Learn how to pronounce the letter ㅎ!",
        Difficulty: "Beginner 1",
        Image: hDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_H_DECK",
        cssId: "cv_h_ID"
    },
        {
        id: "cv_kk",
        Title: "ㄲ (kk)",
        Description: "Learn how to pronounce the letter ㄲ!",
        Difficulty: "Beginner 1",
        Image: kkDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_KK_DECK",
        cssId: "cv_kk_ID"
    },
        {
        id: "cv_tt",
        Title: "ㄸ (tt)",
        Description: "Learn how to pronounce the letter ㄸ!",
        Difficulty: "Beginner 1",
        Image: ttDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_TT_DECK",
        cssId: "cv_tt_ID"
    },
        {
        id: "cv_pp",
        Title: "ㅃ (pp)",
        Description: "Learn how to pronounce the letter ㅃ!",
        Difficulty: "Beginner 1",
        Image: ppDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_PP_DECK",
        cssId: "cv_pp_ID"
    },
        {
        id: "cv_ss",
        Title: "ㅆ (ss)",
        Description: "Learn how to pronounce the letter ㅆ!",
        Difficulty: "Beginner 1",
        Image: ssDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_SS_DECK",
        cssId: "cv_ss_ID"
    },
        {
        id: "cv_jj",
        Title: "ㅉ (jj)",
        Description: "Learn how to pronounce the letter ㅉ!",
        Difficulty: "Beginner 1",
        Image: jjDeckIMG,
        Link: "/CONSONANT_VOWEL_PAIRS_JJ_DECK",
        cssId: "cv_jj_ID"
    },
]

    export function BasicsDeckFaceCard() {
        return (
    
            <FaceCardFormatterDeck FaceCard={BasicsDeckFace}/>
        
        )
    
    }